<template>
  <v-data-table
    :hide-default-footer="hideDefaultFooter"
    :headers="tableHeaders"
    :items="tableItems"
  >
    <!-- table actions -->
    <template v-if="tableActions" v-slot:[`item.actions`]="{ index }">
      <BaseButton
        v-if="tableActions.delete"
        depressed
        flat
        small
        link
        icon="mdi-minus-circle"
        iconSize="large"
        iconColor="error"
        text="REMOVE"
        class="px-0"
        @click="deleteItem(index)"
      />
    </template>
  </v-data-table>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton";

export default {
  name: "BaseTable",
  props: {
    tableHeaders: {
      type: Array,
      required: true,
    },
    tableItems: {
      type: Array,
      required: true,
    },
    tableActions: {
      type: Object,
      default: null,
    },
    hideDefaultFooter: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BaseButton,
  },
  methods: {
    deleteItem(rowIndex) {
      this.$emit("deleteItem", rowIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table {
  :deep(.v-data-table__wrapper) {
    thead th,
    tbody td {
      border-bottom: 2px solid rgba(0, 0, 0, 0.12) !important;
    }
  }
}
</style>
